{
  "actionbar.actions": "Actions",
  "actionbar.actionsAvailable": "Actions disponibles.",
  "actionbar.clearSelection": "Supprimer la sélection",
  "actionbar.selected": "{count, plural, =0 {Aucun élément sélectionné} other {# sélectionnés}}",
  "actionbar.selectedAll": "Toute la sélection",
  "breadcrumbs.more": "Plus d’éléments",
  "button.pending": "En attente",
  "combobox.noResults":  "Aucun résultat",
  "contextualhelp.help": "Aide",
  "contextualhelp.info": "Informations",
  "dialog.alert": "Alerte",
  "dialog.dismiss": "Rejeter",
  "dropzone.replaceMessage": "Déposer le fichier à remplacer",
  "inlinealert.informative": "Informations",
  "inlinealert.negative": "Erreur",
  "inlinealert.notice": "Avertissement",
  "inlinealert.positive": "Succès",
  "label.(optional)": "(facultatif)",
  "label.(required)": "(requis)",
  "menu.moreActions": "Autres actions",
  "notificationbadge.indicatorOnly": "Nouvelle activité",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Sélectionner…",
  "slider.maximum": "Maximum",
  "slider.minimum": "Minimum",
  "table.loading": "Chargement...",
  "table.loadingMore": "Chargement supplémentaire...",
  "table.resizeColumn": "Redimensionner la colonne",
  "table.sortAscending": "Trier par ordre croissant",
  "table.sortDescending": "Trier par ordre décroissant",
  "tag.actions": "Actions",
  "tag.hideButtonLabel": "Afficher moins",
  "tag.noTags": "Aucun",
  "tag.showAllButtonLabel": "Tout afficher ({tagCount, number})",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}
